import { render, staticRenderFns } from "./SelectTaxRegime.vue?vue&type=template&id=7d393d52&"
import script from "./SelectTaxRegime.vue?vue&type=script&lang=js&"
export * from "./SelectTaxRegime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports